import { ChainId } from '@donaswap/sdk'

export const masterChefAddresses = {
    [ChainId.BSC_TESTNET]: '0x0000000000000000000000000000000000000000',
    [ChainId.BSC]: '0x0000000000000000000000000000000000000000',
  } as const